import { Routes } from '@angular/router';

export const userRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/dt-users/dt-users.component').then(
        (m) => m.DtUsersComponent,
      ),
  },
];
